import {WAITING_NEWS_URL} from "../../helpers/api.routes";
import {requests} from "../../helpers/api.services";

export const AdminWaitingNewsService = {
    getAll: (params: any) => requests.get(WAITING_NEWS_URL, params),
    update: (ids: number[]) => requests.put(WAITING_NEWS_URL, {ids})
};
